import { render, staticRenderFns } from "./AgentCard.vue?vue&type=template&id=32a7f234&"
import script from "./AgentCard.vue?vue&type=script&lang=js&"
export * from "./AgentCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports